export default {
  options: {
    store_types: [
      { id: 1, name: '量販' },
      { id: 2, name: '超市' },
    ],
    store_areas: [
      { id: 1, name: '台北市地區' },
      { id: 2, name: '宜花東地區' },
    ],
    store_groups: [
      { id: 1, name: '北北區' },
      { id: 2, name: '北南區' },
    ],
    service_categories: [
      {
        id: '6abf74d1-f3d8-4370-ab27-287999d8d5f5',
        name: '服務中心',
        items: [
          {
            id: '5be46471-a3dd-406c-a298-59b4eb920462',
            name: 'VIP咖啡機',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/5be46471-a3dd-406c-a298-59b4eb920462/09377880-7b79-44af-9fa9-38292e1b1b53.png',
          },
          {
            id: 'd2b7b9ed-a67d-4657-86a0-0bcbd33c3ef1',
            name: '不滿意可退貨',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/d2b7b9ed-a67d-4657-86a0-0bcbd33c3ef1/c6afb56c-0f31-4b00-be94-510f7abfe927.png',
          },
          {
            id: '1b74e941-1ef3-4d93-84b2-cc6b327b5b8a',
            name: '乾洗服務站',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/1b74e941-1ef3-4d93-84b2-cc6b327b5b8a/a9baf3c4-ae4b-475e-8344-ce7a34b73306.png',
          },
          {
            id: '4466040c-06f8-471f-83f3-217d07681777',
            name: '二手3C變購物金',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/4466040c-06f8-471f-83f3-217d07681777/e97b2054-910b-4015-862a-1d4fb348e01f.png',
          },
          {
            id: '9e5c506d-e10a-4610-843c-0c74bd28b98e',
            name: '享樂券',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/9e5c506d-e10a-4610-843c-0c74bd28b98e/204d2712-49fb-478b-8cc6-72d3c70c6885.png',
          },
          {
            id: '2ca3d394-7e1e-4360-9327-54a6c855b6c5',
            name: '休憩區',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/2ca3d394-7e1e-4360-9327-54a6c855b6c5/1992f110-bd16-4760-aa21-2f0da7786901.png',
          },
          {
            id: 'c6c521d7-f59b-453a-9244-a6d6600ccee6',
            name: '便利銀行',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/c6c521d7-f59b-453a-9244-a6d6600ccee6/b054cae3-7151-4aed-aa98-92a7468ec376.png',
          },
          {
            id: 'e9c97b62-ef1c-456b-8a02-e792613844af',
            name: '便當訂購服務',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/e9c97b62-ef1c-456b-8a02-e792613844af/538b9051-2fd9-4cc1-8f20-c0924cf2628c.png',
          },
          {
            id: '9f6005d8-4c81-492f-89f7-d92b7986d95c',
            name: '保冷袋',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/9f6005d8-4c81-492f-89f7-d92b7986d95c/629dd103-de97-4506-893a-e26dbf57dc07.png',
          },
          {
            id: '4400e4a2-9db9-4dda-b215-b89b7661b54d',
            name: '傢俱商品宅配服務',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/4400e4a2-9db9-4dda-b215-b89b7661b54d/30f9cffb-2770-4455-b53a-9db3966103b3.png',
          },
          {
            id: '61e88c0d-e4fe-4b1d-a438-dcb20a7a2080',
            name: '免費冰塊',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/61e88c0d-e4fe-4b1d-a438-dcb20a7a2080/13ca13e6-9dbe-4172-95fb-13aad7db4eba.png',
          },
        ],
      },
      {
        id: '0c5f9d29-def3-4592-8d1f-a570cc5e41be',
        name: '其他服務',
        items: [
          {
            id: '4701d010-b47f-47b3-935f-e6a4c4b38393',
            name: '中獎發票兌換-五獎&六獎',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/4701d010-b47f-47b3-935f-e6a4c4b38393/60d96cef-b9fa-4d2d-97f8-79630b219b8f.png',
          },
        ],
      },
    ],
    brand_categories: [
      {
        id: '00fb7c8d-e18f-4615-b6dd-5ced270d9219',
        name: '家電 / 通訊 / 3C',
        items: [
          {
            id: 'de96e13d-d8bd-40e0-87d4-bc9bb0ea14a1',
            name: 'BEST電器',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Best_Logo_300x300.jpg',
          },
          {
            id: '7361db02-92f3-42bd-af34-6c0ae6ddd161',
            name: 'LG',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7361db02-92f3-42bd-af34-6c0ae6ddd161/047376b5-8923-4ba4-94c7-bc19b5e9a812.jpg',
          },
          {
            id: 'f3563b1f-1596-48f4-a028-92c5c4f01392',
            name: 'NOKIA',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/nokia_300x300.jpg',
          },
          {
            id: 'dc66a9f1-67dd-4b89-80f2-35b01225c800',
            name: 'NOVA',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dc66a9f1-67dd-4b89-80f2-35b01225c800/c75761da-3152-4064-a9fa-6c8cd9b73581.jpg',
          },
          {
            id: 'd77417e0-c72e-4738-9812-122a1faa381a',
            name: 'PYXIS',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Pyxis_300x300.jpg',
          },
          {
            id: '43d46df9-7410-4356-83b8-abb73b29d692',
            name: 'Samsung',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/samsung_300x300.jpg',
          },
          {
            id: '7321fa71-4ecf-4607-acbf-9317ccbfb2e4',
            name: 'SONY',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/sony_300x300.jpg',
          },
          {
            id: 'd64dfd76-c451-48ea-88d5-84609b1c9289',
            name: '仙德曼',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d64dfd76-c451-48ea-88d5-84609b1c9289/3c3d1ab6-249c-457d-9b3b-b446e88260ac.jpg',
          },
          {
            id: '8fc91ba7-d438-49ad-beec-75035a60a470',
            name: '吸霸',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/',
          },
          {
            id: 'af2895f0-62a1-4307-bcb2-b085e01c7bef',
            name: '德國海豚',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/af2895f0-62a1-4307-bcb2-b085e01c7bef/bdb56a76-3d83-4188-92c9-a2d4eb2e44ce.jpg',
          },
          {
            id: 'fab088f0-04d2-4e95-8698-a10b6ad6d847',
            name: '百享科技',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/richman_300x300.jpg',
          },
          {
            id: '7fe7c349-6e48-4263-8664-974669e483d4',
            name: '順發',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7fe7c349-6e48-4263-8664-974669e483d4/d738503a-8b4a-4519-8316-6f36926c1c4b.jpg',
          },
        ],
      },
      {
        id: '0630e6fa-a5df-468b-bb9e-047669677603',
        name: '教育 / 學習 / 諮詢',
        items: [
          {
            id: '579df2af-d724-49b7-b69b-3694ca8e8477',
            name: '金石堂',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Kingstone_300x300.jpg',
          },
        ],
      },
    ],
    food_categories: [
      {
        id: 1,
        name: '輕食點心',
        items: [
          {
            id: 'ff773a48-f96c-43f9-96e2-4c43447c2860',
            name: 'Häagen-Dazs',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Haagan_300x300.jpg',
          },
          {
            id: '7ce6e2e7-85c1-458f-82f7-8bedca6cecf2',
            name: 'Mister Donut 多拿滋先生',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Mister_300x300.jpg',
          },
          {
            id: '42ccbcdc-d46f-47cb-9f2e-224739b9679d',
            name: 'Yamazaki 山崎麵包',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/42ccbcdc-d46f-47cb-9f2e-224739b9679d/e8d875c4-151f-4e95-a832-0d82a3601e8d.jpg',
          },
          {
            id: '4364e8c4-d1e6-4379-bdb3-88f4fa474daf',
            name: 'Zen Q',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4364e8c4-d1e6-4379-bdb3-88f4fa474daf/97cd9d48-9592-4fe4-9121-b1ea53e4d07b.jpg',
          },
          {
            id: '8b990877-8c1f-4f52-949f-a03d46581ad1',
            name: '丹堤咖啡',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b990877-8c1f-4f52-949f-a03d46581ad1/7c01eebb-3e44-44dd-b192-4211ca9b9eea.jpg',
          },
          {
            id: '2838c4a4-1c1d-4fcd-bbca-dd5a149553df',
            name: '京都苑',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2838c4a4-1c1d-4fcd-bbca-dd5a149553df/7c4a5425-652d-4808-b221-79d6cbc1c8f9.jpg',
          },
          {
            id: '80135b2a-de42-42d0-b194-ffcb6dd3b3e3',
            name: '八月堂',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/80135b2a-de42-42d0-b194-ffcb6dd3b3e3/06537889-502d-4e56-a79d-7f141d90db30.jpg',
          },
          {
            id: 'bd9040f3-f332-43ca-879d-19f741643096',
            name: '包心粉圓',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bd9040f3-f332-43ca-879d-19f741643096/a2eecaa6-962e-44db-91dd-7f1491cdfd87.jpg',
          },
          {
            id: '798af07b-2338-425c-add5-8c2d35c8af0d',
            name: '匠喝',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/798af07b-2338-425c-add5-8c2d35c8af0d/7ee4aaaa-5f7c-4792-b3d1-51dc02efd095.jpg',
          },
          {
            id: '4d790c1b-ea76-46cb-bf69-7f31191908f1',
            name: '半雞八兩',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d790c1b-ea76-46cb-bf69-7f31191908f1/8c685470-ad02-47af-9b56-7a0fab1041d3.jpg',
          },
          {
            id: 'cc99dca6-6749-4a73-b5d9-44bbaf1723d2',
            name: '咖啡先生',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cc99dca6-6749-4a73-b5d9-44bbaf1723d2/4561405d-762b-4122-ab60-99b0436c5e75.jpg',
          },
          {
            id: '2999fd26-deef-47c6-8c11-b849b5026daa',
            name: '哈根達斯',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2999fd26-deef-47c6-8c11-b849b5026daa/71159304-96a0-46dc-8fee-918fa35b07dc.jpg',
          },
          {
            id: 'cb380a5f-3474-4088-9e9b-4aa4a0366e4e',
            name: '均均紅豆餅',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cb380a5f-3474-4088-9e9b-4aa4a0366e4e/aee22aa9-3a33-4786-8d6b-ebaffdb4858f.jpg',
          },
          {
            id: '0701501d-ac69-4d62-a729-2dbef6137652',
            name: '大象山',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Da_300x300.jpg',
          },
          {
            id: '98cb49d6-8c1f-434d-a165-7d2e4147544b',
            name: '山茶園',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98cb49d6-8c1f-434d-a165-7d2e4147544b/de8f49c9-2d7e-41fb-a1c2-8278fef23fb3.jpg',
          },
          {
            id: '3a628197-8287-4af1-bc6c-dfa8ca026383',
            name: '怡客咖啡',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3a628197-8287-4af1-bc6c-dfa8ca026383/b17a5386-da44-4b9c-a263-0c30bf011a8a.jpg',
          },
          {
            id: 'e5ebef7a-33c3-40e8-905f-17e0deae60a9',
            name: '法爵',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e5ebef7a-33c3-40e8-905f-17e0deae60a9/bfecc94f-b3c0-4d6b-b418-787fa97c48e4.jpg',
          },
          {
            id: '4a1cf24a-8821-465c-bd3a-ea2c4928629b',
            name: '滷底撈',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4a1cf24a-8821-465c-bd3a-ea2c4928629b/14ad323e-2ea1-4913-8a8c-75e33cdc636c.jpg',
          },
          {
            id: '0a710bf7-dd22-4ebd-9383-f6c9a780822a',
            name: '炸鷄大獅',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0a710bf7-dd22-4ebd-9383-f6c9a780822a/6d5b099f-02af-48ab-8a80-e6fab249cb47.png',
          },
          {
            id: '3e7fe1f5-025b-4d76-b556-78eb837e36ce',
            name: '私房小廚店',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3e7fe1f5-025b-4d76-b556-78eb837e36ce/caceb09a-a3a8-4351-8e1a-b26b1a5787d1.jpg',
          },
          {
            id: 'e84a04e3-8215-46e0-8d8b-5cdbefe4358b',
            name: '紅玉滿赤心雞蛋糕',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e84a04e3-8215-46e0-8d8b-5cdbefe4358b/673b07ee-a053-4137-b8c7-3b9af72188f3.jpg',
          },
          {
            id: 'f2a914e7-3618-4ac4-98ab-fc6fc055870c',
            name: '老蔡水煎包',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f2a914e7-3618-4ac4-98ab-fc6fc055870c/aedc7ad2-d09b-44a0-a8a8-02b037ca6a47.jpg',
          },
          {
            id: 'cf68a166-93c4-420c-afe7-652884ccc7e4',
            name: '薔薇派',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cf68a166-93c4-420c-afe7-652884ccc7e4/a75f769b-405a-4fac-87f9-c4c097bd6dde.jpg',
          },
          {
            id: 'e10a8e62-d73a-4496-b97b-41fd2eb63145',
            name: '許留山',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e10a8e62-d73a-4496-b97b-41fd2eb63145/edeb3912-e9c3-426a-b5d7-067cc3a2f5d9.jpg',
          },
          {
            id: '089cd74c-cb14-4c03-bb2e-9989debcad27',
            name: '酷聖石',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/cold_stone_300x300.jpg',
          },
          {
            id: 'c54ae1a0-6544-4488-a5c5-059902d29bc4',
            name: '醇蛋糕',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c54ae1a0-6544-4488-a5c5-059902d29bc4/3617cdeb-c714-4f38-a7f0-566fcd26938c.jpg',
          },
          {
            id: '4d387614-7a9a-4f99-aa2f-85e81e0c039a',
            name: '陸家班',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d387614-7a9a-4f99-aa2f-85e81e0c039a/007271de-9e1e-41fe-99f3-f77d765df7cf.jpg',
          },
          {
            id: 'e7ce0b9b-5688-44f0-b6ab-e9a1156a2307',
            name: '風和家現烤烘焙',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e7ce0b9b-5688-44f0-b6ab-e9a1156a2307/3c649c9e-eb20-4873-887b-d186bdcb05b6.jpg',
          },
          {
            id: '98516093-278b-4da2-8f6d-7a3edd1dd1c0',
            name: '麥當勞點心吧',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98516093-278b-4da2-8f6d-7a3edd1dd1c0/be9d3399-b134-409d-92b2-af4a3562fd72.jpg',
          },
        ],
      },
      {
        id: 2,
        name: '咖啡茶飲',
        items: [
          {
            id: '1bc0a8de-0071-4e6c-aa9e-38b9386b5366',
            name: '50嵐',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1bc0a8de-0071-4e6c-aa9e-38b9386b5366/671fb07f-0f0f-4745-94f5-7ebd73d8f56d.jpg',
          },
          {
            id: 'fc2cc3db-156e-4426-8677-de0fdfd5bc84',
            name: '85度C',
            image:
              'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fc2cc3db-156e-4426-8677-de0fdfd5bc84/cefc4f9d-29a0-433c-8f5e-9fa48e0882fa.jpg',
          },
        ],
      },
    ],
    citys: [
      {
        id: 1,
        name: '臺北市',
        children: [
          {
            id: 1,
            name: '中正區',
            zip: '100',
          },
          {
            id: 2,
            name: '大同區',
            zip: '103',
          },
          {
            id: 3,
            name: '中山區',
            zip: '104',
          },
          {
            id: 4,
            name: '松山區',
            zip: '105',
          },
          {
            id: 5,
            name: '大安區',
            zip: '106',
          },
          {
            id: 6,
            name: '萬華區',
            zip: '108',
          },
          {
            id: 7,
            name: '信義區',
            zip: '110',
          },
          {
            id: 8,
            name: '士林區',
            zip: '111',
          },
          {
            id: 9,
            name: '北投區',
            zip: '112',
          },
          {
            id: 10,
            name: '內湖區',
            zip: '114',
          },
          {
            id: 11,
            name: '南港區',
            zip: '115',
          },
          {
            id: 12,
            name: '文山區',
            zip: '116',
          },
        ],
      },
    ],
  },
}



// WEBPACK FOOTER //
// ./src/libs/ConfigData.js